/** Fallback business line, shown when `app_settings.business_phone` is unset or unusable. */
export const DISPLAY_PHONE = "289-536-3126";

/**
 * Build an RFC 3966 `tel:` href from a loosely-formatted phone string.
 * "289-536-3126" / "(289) 536-3126" -> "tel:+12895363126". A bare 10-digit
 * number is assumed North American (+1). Used by click-to-call surfaces so the
 * dialer always gets a clean, country-coded number regardless of display format.
 */
export function toTelHref(raw: string | null | undefined): string {
  const digits = (raw ?? "").replace(/\D/g, "");
  if (!digits) return "tel:";
  if (digits.length === 10) return `tel:+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `tel:+${digits}`;
  return `tel:+${digits}`;
}
